import { Card, Button, Space, Tooltip, Form, message, Empty, Modal } from "antd";
import { DoubleLeftOutlined, SyncOutlined, DoubleRightOutlined, SaveOutlined, CheckOutlined, UnorderedListOutlined, ApartmentOutlined, UserOutlined } from "@ant-design/icons";
import { useShallow } from "zustand/react/shallow";
import useStore from "@/pages/documentCompile/store/useStore";
import useMethods from "@/pages/documentCompile/onlyofficeFieldSetting/hooks/usemethods";
import { renderFormItem } from "@/pages/documentCompile/dict/help";
import styles from "./index.module.less";
import { useEffect, useMemo, useRef, useState } from "react";
import { getTreeFields, getTreeNode, traverseTree } from "@/utils/tree";
import { getCurrentEditor, saveDocument } from "@/pages/documentCompile/onlyofficeFieldSetting/utils";
import { DocumentSettingType, FieldType } from "@/pages/documentCompile/type";
import { isNotUndefined } from "@/utils/tools";
import { getArrayFromArrayString } from "@/utils/arr";
import { DomainField, renderFieldFormItem } from "./help";
import { EnterpriseCustomGroupKeys, PersonCustomGroupKeys, PersonCustomGroupMap } from "@/pages/documentCompile/domain/components/editModal/constant";
import PersonTableModal from "@/pages/documentCompile/baseInfo/personInfo/components/PersonTableModal";
import EnterpriseTableModal from "@/pages/documentCompile/baseInfo/enterpriseInfo/components/enterpriseTableModal";
import useInitData from "@/pages/documentCompile/onlyofficeFieldSetting/hooks/useInitData";
import clsx from "clsx";
import { ReactComponent as DSAuditIcon } from '@/assets/svg/ds-audit.svg'
import { confirmAsync } from "@/utils/antd-help";
import FlatDomainForm from './components/FlatDomainForm';
import TreeDomainForm from './components/TreeDomainForm';
import SignImageModal from './components/signModal'
import { EDITOR_ID } from "@/pages/documentCompile/onlyofficeFieldSetting";
import { updateProjectDoc } from "@/pages/documentCompile/api/data-project-doc";
import { deepClone } from "@/utils/obj";

interface IProps {
    open: boolean
    isUnmountedRef: React.RefObject<boolean>;
    requestId: string
}
export default function DomainFormCard({ open, isUnmountedRef, requestId }: IProps) {
    const [form] = Form.useForm();
    const refData = useRef<any>({})
    const [personBaseInfoModalVisible, setPersonBaseInfoModalVisible] = useState(false);
    const [enterpriseBaseInfoModalVisible, setEnterpriseBaseInfoModalVisible] = useState(false);
    const setStoreState = useStore.setState
    const [signImageModalVisible, setSignImageModalVisible] = useState(false);
    const { handleAsyncReplaceFieldValue, processFormData, asyncFormData, doReplaceFieldValue, generateEditorConfig } = useMethods();
    const { refreshPackageFolderTreeData, initDomainSettingData } = useInitData()
    const { domainTreeData, allDomainTagMap, domainTreeDataExpandedKeys, domainTreeCardExpanded, setDomainTreeCardExpanded, editorConfig, settingDomainFormData, usedDomainDocDataMap, isEditMode, domainShowType } = useStore(
        useShallow((s) => ({
            usedDomainDocDataMap: s.usedDomainDocDataMap,
            domainTreeData: s.domainTreeData,
            domainTreeDataExpandedKeys: s.domainTreeDataExpandedKeys,
            domainTreeCardExpanded: s.domainTreeCardExpanded,
            setDomainTreeCardExpanded: s.setDomainTreeCardExpanded,
            editorConfig: s.editorConfig,
            allDomainTagMap: s.allDomainTagMap,
            settingDomainFormData: s.settingDomainFormData,
            isEditMode: s.isEditMode,
            domainShowType: s.domainShowType,
        }))
    );

    // 处理卡片展开/折叠
    const handleCardExpand = () => {
        setDomainTreeCardExpanded(!domainTreeCardExpanded);
    };

    // 处理展示类型切换
    const handleShowTypeChange = (type: 'flat' | 'tree') => {
        setStoreState({ domainShowType: type });
    };

    const handleSignField = async () => {
        console.log("handleSignField")
    }

    const handleSyncField = async () => {
        const latestDocumentSettingProjectData = useStore.getState().documentSettingProjectData
        // const latestEditorConfig = useStore.getState().editorConfig
        const latestEditorConfigBack = useStore.getState().editorConfigBack

        setStoreState({
            // documentLoading: true,
            editorConfigLoading: true,
        })

        // 保存文档
        let saveResUrl = "";
        try {
            const selectedFileData = useStore.getState().selectedFileData
            if (!selectedFileData?.id) {
                message.error("未找到文档ID");
                return;
            }
            // 先保存文档，（不保存文档的话，状态会有问题）
            const result = await saveDocument({
                fileName: latestDocumentSettingProjectData.documentDetail.fileName || latestDocumentSettingProjectData.documentDetail.documentName,
                editorConfig: latestEditorConfigBack,
                isUnmountedRef: isUnmountedRef,
            });
            if (result.success && result.fileUrl && result.modify) {
                saveResUrl = result.fileUrl
                const params = {
                    "docId": latestDocumentSettingProjectData.documentDetail.id,
                    "docUrl": result.fileUrl,
                    "projectId": latestDocumentSettingProjectData.documentDetail.projectId,
                }
                await updateProjectDoc(params, requestId)
            }
        } catch (error) {
            message.warning("保存失败")
            setStoreState({
                editorConfigLoading: false,
            })
        }
        // 同步域
        try {
            const selectedFileData = useStore.getState().selectedFileData
            const isExistEmptyDomainField = useStore.getState().isExistEmptyDomainField
            if (!selectedFileData?.id) {
                message.error("未找到文档ID");
                return;
            }
            // 确认弹窗
            if (isExistEmptyDomainField) {
                const confirmed = await confirmAsync({
                    title: '检测到有字段值被清空，确认继续？',
                    // content: '此操作不可撤销，是否继续？',
                    okText: '继续',
                    cancelText: '取消'
                });
                if (!confirmed) {
                    // message.warning("请先填写完整域值");
                    return;
                }
            }
            // 先保存文档
            // message.info("正在保存文档...");
            setStoreState({
                // documentLoading: true,
                editorConfigLoading: true,
            })
            doReplaceFieldValue();
            await handleAsyncReplaceFieldValue()
            refreshPackageFolderTreeData()
            setStoreState({
                editorConfigLoading: false,
            })

            message.success("同步成功");
        } catch (error) {
            setStoreState({
                editorConfigLoading: false,
            })
            message.error("同步失败");
            console.error("同步失败:", error);
        }
    };
    const handleSingClick = () => {
        const signImageRes = useStore.getState().signImageRes
        if (!signImageRes?.picFileUrl) {
            message.error("你未上传签名文件，请联系管理员上传个人签名文件！");
            return;
        }
        setSignImageModalVisible(true)
    }
    const handleFormValuesChange = (changedFields: any, allFields: any) => {
        console.log("handleFormValuesChange", changedFields, allFields)
        const settingDomainFormData = useStore.getState().settingDomainFormData
        const newSettingDomainFormData = { ...settingDomainFormData }
        Object.keys(changedFields).forEach(key => {
            newSettingDomainFormData[key] = changedFields[key]
        })
        setStoreState({
            settingDomainFormData: newSettingDomainFormData,
        });
    };
    const flatNodes = useMemo(() => {
        const flatNode = [];
        traverseTree(domainTreeData, (node) => {
            if (!node.noField && node.isDomain && usedDomainDocDataMap[node.fieldTag]) {
                flatNode.push(node);
            }
        });
        return flatNode;
    }, [domainTreeData, usedDomainDocDataMap])

    const hanldeTestSing = () => {
        const signImageRes = useStore.getState().signImageRes


        // const editor = window.DocEditor?.instances[EDITOR_ID];
        // if (!editor) {
        //     message.error("编辑器未准备就绪");
        //     return;
        // }
        // const connector = editor.createConnector();
        // window.Asc = window.Asc || {};
        // window.Asc.scope = window.Asc.scope || {};
        // window.Asc.scope.picFileUrl = signImageRes.picFileUrl;
        // connector.callCommand(() => {
        //     const picFileUrl = Asc.scope.picFileUrl;
        //     console.log("picFileUrl", picFileUrl)
        //     let doc = Api.GetDocument();
        //     let images = doc.GetAllImages();
        //     const currentImage = images[0]
        //     let classType = currentImage.GetClassType();
        //     console.log("images", images)
        //     console.log("classType", classType)
        //     currentImage.Select();
        //     const defaultAvatar = 'https://stone-1317531803.cos.ap-shanghai.myqcloud.com/avatar/avatar.png?q-sign-algorithm=sha1&q-ak=AKIDg1QR_r25PJRFFCmonBa7mJOVHgubzUNEXLCatVaRHM-Pc8-9MVY56pI6QlkidxB7&q-sign-time=1755014048;1755017648&q-key-time=1755014048;1755017648&q-header-list=host&q-url-param-list=ci-process&q-signature=fee6b3f35dbbc1b0b58ddc1c053242dc3da2fac3&x-cos-security-token=gcEeDvB1cYZHwv4ncTG7J3iZRgeJj1Ta96f820ac3963cda092e511567f8f64cepfApqvWmxm1Evjws6-lw5Ud6g93mY5hi58DC4fkJ8Tj9voHH3nL_1eiMyZfw8-J8x14U9Kg63ch5mrh0_LfWIXdgn7ui_HjFoCYXH_iXanctxQAQORdH3qtr_DU2T0raB31z8grbDvzc0PBELT3zfeo9xWFT8FwAhYftZghDL1ZB464Gw1piSO02r48V9sif6FDkJzsnRjFiTinsWDzeLeTMJ7Tiw42vyPf_kgo8-FTfGTkuNgJ8xOB5dH3HOteNRTPg8VK4sCf1iS6cLr3k1g&ci-process=originImage'
        //     doc.ReplaceCurrentImage(defaultAvatar, 60 * 36000, 35 * 36000);
        // })
    }

    const extra = (
        <Space>
            {/* <Tooltip title={domainTreeCardExpanded ? "折叠卡片" : "展开卡片"}>
                <Button
                    type="text"
                    icon={domainTreeCardExpanded ? <DoubleRightOutlined /> : <DoubleLeftOutlined />}
                    size="small"
                    onClick={handleCardExpand}
                />
            </Tooltip> */}

            {/* <Tooltip placement='bottom' title='出库'>
                <Button type='link' size='small' className='c1f1f1f' icon={<DSPutOutStorageIcon className={styles['ci-put-out-storage']} />} onClick={() => handleAudit(engDetailData, '出库', DataStatusEnum.collect)}>
                </Button>
            </Tooltip>
             */}

            {/* <Tooltip title="刷新">
                <Button
                    type="text"
                    className={clsx("hover-icon")}
                    icon={<SyncOutlined />}
                    size="small"
                    onClick={handleRefresh}
                />
            </Tooltip> */}

            <Tooltip title="签名">
                <Button
                    type="text"
                    className={clsx("hover-icon")}
                    icon={<UserOutlined />}
                    size="small"
                    onClick={handleSingClick}
                    disabled={!isEditMode}
                />
            </Tooltip>

            <Tooltip title={domainShowType === 'flat' ? "切换为树形展示" : "切换为平级展示"}>
                <Button
                    type="text"
                    className={clsx(styles.displayTypeBtn, "hover-icon")}
                    icon={domainShowType === 'flat' ? <ApartmentOutlined /> : <UnorderedListOutlined />}
                    onClick={() => handleShowTypeChange(domainShowType === 'flat' ? 'tree' : 'flat')}
                />
            </Tooltip>

            <Tooltip title={isEditMode ? "保存并同步" : "请先解锁编辑模式"}>
                <Button
                    type="text"
                    className={clsx("hover-icon")}
                    icon={<CheckOutlined />}
                    size="small"
                    onClick={handleSyncField}
                    disabled={!isEditMode}
                />
            </Tooltip>
            {/* <Button onClick={hanldeTestSing}>测试签名</Button> */}
        </Space >
    );

    const handleSearch = (item: DomainField, parentItem?: DomainField) => {
        refData.current.fieldItem = item
        if (parentItem) {
            refData.current.parentItem = parentItem
        }
        const epid = localStorage.getItem('epid')
        if (!epid) return;
        // const fieldTag = item.fieldTag
        const fieldType = item?.fieldType || parentItem?.fieldType
        if (fieldType === FieldType.SYSTEM_COMPANY) {
            setEnterpriseBaseInfoModalVisible(true)
        }
        if (fieldType === FieldType.SYSTEM_PERSON) {
            setPersonBaseInfoModalVisible(true)
        }
        // const customFormPrefix = item.fieldPrefix || fieldTag?.split(epid)?.[0]?.replaceAll('_', '')
        // if (customFormPrefix) {
        //     const isEnterprise = EnterpriseCustomGroupKeys.includes(customFormPrefix)
        //     const isPerson = PersonCustomGroupKeys.includes(customFormPrefix)
        //     if (isEnterprise) {
        //         setEnterpriseBaseInfoModalVisible(true)
        //     }
        //     if (isPerson) {
        //         setPersonBaseInfoModalVisible(true)
        //     }
        //     console.log('customFormPrefix', customFormPrefix)
        // }
    }


    const handlePersonBaseInfoModalOk = (item: any) => {
        console.log("data", item)
        const fieldItem = refData.current.fieldItem
        const parentItem = refData.current.parentItem
        // const fieldTag = fieldItem.fieldTag
        const parentId = fieldItem?.parentId || parentItem.id
        // const epid = localStorage.getItem('epid')
        // const customFormPrefix = fieldTag?.split(epid)?.[0]
        if (!parentId) return;
        const changeValues = asyncFormData(parentId, item)
        form.setFieldsValue(changeValues)
        setPersonBaseInfoModalVisible(false)
    }

    const handleEnterpriseBaseInfoModalOk = (item: any) => {
        const fieldItem = refData.current.fieldItem
        const parentItem = refData.current.parentItem
        // const fieldTag = fieldItem.fieldTag
        const parentId = fieldItem?.parentId || parentItem.id
        // const columnField = fieldItem?.fieldValue
        // const epid = localStorage.getItem('epid')
        // const customFormPrefix = fieldTag?.split(epid)?.[0]
        if (!parentId) return;
        const changeValues = asyncFormData(parentId, item)
        form.setFieldsValue(changeValues)
        setEnterpriseBaseInfoModalVisible(false)
    }
    //  NOTE: 签名需要实时替换文档图片，但是前端无法替换，所以需要后端替换
    const handleSignImageModalOk = async () => {
        const latestDocumentSettingProjectData = useStore.getState().documentSettingProjectData
        setSignImageModalVisible(false)
        setStoreState({
            editorConfigLoading: true,
        })
        let saveResUrl = ""
        // 同步修改文档中的域
        doReplaceFieldValue();
        try {
            const selectedFileData = useStore.getState().selectedFileData
            if (!selectedFileData?.id) {
                message.error("未找到文档ID");
                return;
            }
            // 先保存文档
            const result = await saveDocument({
                fileName: latestDocumentSettingProjectData.documentDetail.fileName || latestDocumentSettingProjectData.documentDetail.documentName,
                editorConfig: editorConfig,
                isUnmountedRef: isUnmountedRef,
            });
            if (result.success && result.fileUrl && result.modify) {
                saveResUrl = result.fileUrl
                const params = {
                    "docId": latestDocumentSettingProjectData.documentDetail.id,
                    "docUrl": result.fileUrl,
                    "projectId": latestDocumentSettingProjectData.documentDetail.projectId,
                }
                await updateProjectDoc(params, requestId)
            } else {

            }
            setStoreState({
                isOnlyOfficeDocumentModified: false,
            })
        } catch (error) {
            message.warning("保存失败")
            setStoreState({
                editorConfigLoading: false,
            })
        }
        try {
            await handleAsyncReplaceFieldValue()
            await refreshPackageFolderTreeData()
            setStoreState({
                editorConfigLoading: false,
            })
            message.success("同步成功");
            setSignImageModalVisible(false)
        } catch (error) {
            setStoreState({
                editorConfigLoading: false,
            })
            message.error("同步失败");
            console.error("同步失败:", error);
        }
        // 刷新文档
        try {
            const fileName = latestDocumentSettingProjectData.documentDetail.fileName || latestDocumentSettingProjectData.documentDetail.documentName || latestDocumentSettingProjectData.documentDetail.name;
            const fileId = latestDocumentSettingProjectData.documentDetail.id || latestDocumentSettingProjectData.documentDetail.fileId;
            const packageFolderTreeData = useStore.getState().packageFolderTreeData
            let findNode = getTreeNode(packageFolderTreeData, node => node.id === fileId)
            if (!findNode.docUrl) {
                setStoreState({
                    editorConfigLoading: false,
                })
                return;
            }
            const queryParams = {
                fileUrl: findNode.docUrl,
                fileName
            };
            const editorConfig = await generateEditorConfig(queryParams);
            const editor = getCurrentEditor()
            console.log("refreshFile", editorConfig)
            editor.refreshFile({ ...editorConfig })
            setStoreState({
                editorConfig: { ...editorConfig },
                editorConfigBack: deepClone(editorConfig)
            })
        } catch (error) {
            setStoreState({
                // editorConfig: { ...editorConfig },
                editorConfigLoading: false,
            })
        }
    }

    useEffect(() => {
        if (settingDomainFormData && Object.keys(settingDomainFormData).length > 0) {
            const processedSettingDomainFormData = processFormData(settingDomainFormData);
            form.setFieldsValue(processedSettingDomainFormData);
        }
        // console.log("settingDomainFormData", settingDomainFormData)
    }, [settingDomainFormData]);

    console.log("flatNodes", domainShowType, flatNodes, usedDomainDocDataMap, personBaseInfoModalVisible, enterpriseBaseInfoModalVisible)
    return (
        <Card
            className={styles.card}
            styles={{ body: { flex: 1, overflow: "auto", padding: domainShowType === 'flat' ? '16px' : '0' } }}
            title="域值设置"
            size="small"
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column"
            }}
            extra={
                extra
            }
        >
            {domainShowType === 'flat' ? (
                <FlatDomainForm
                    flatNodes={flatNodes}
                    form={form}
                    handleFormValuesChange={handleFormValuesChange}
                    handleSearch={handleSearch}
                />
            ) : (
                <TreeDomainForm
                    settingDomainFormData={settingDomainFormData}
                    domainTreeData={domainTreeData}
                    usedDomainDataMap={usedDomainDocDataMap}
                    form={form}
                    handleFormValuesChange={handleFormValuesChange}
                    handleSearch={handleSearch}
                />
            )}
            {personBaseInfoModalVisible ? <PersonTableModal open={personBaseInfoModalVisible} onCancel={() => setPersonBaseInfoModalVisible(false)} onOk={handlePersonBaseInfoModalOk} /> : null}
            {enterpriseBaseInfoModalVisible ? <EnterpriseTableModal
                open={enterpriseBaseInfoModalVisible}
                onOk={handleEnterpriseBaseInfoModalOk}
                onCancel={() => setEnterpriseBaseInfoModalVisible(false)}
            /> : null}
            {
                signImageModalVisible ? <SignImageModal
                    open={signImageModalVisible}
                    onClose={() => setSignImageModalVisible(false)}
                    onOk={handleSignImageModalOk}
                /> : false
            }
        </Card>
    )
}
